import React from 'react';
import './ComponentCss/MonthPaymentChip.css'; // 스타일을 위한 CSS 파일(Optional)
import MonthIcon from '../Image/MonthIcon.png';

const MonthPaymentChip = ({ onClick }) => {
    const handleClick = () => {
        // 부모에서 전달한 onClick 함수 호출
        if (onClick) {
            onClick();  // toggleBox가 호출될 것입니다.
        }
    };

    return (
        <button className="chip" onClick={handleClick}>
            <img className={'MonthIcon'} src={MonthIcon} alt="See more"/>
            <div className={'MonthPaymentChip-Text'}>월별 미납내역</div>
        </button>
    );
};

export default MonthPaymentChip;
